// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tcLhcU3jJTtIByaDkItu {
    display: flex;
    flex-direction: row-reverse;
    margin: 30px 0 -10px;
}

.IgS2F5nCyA_JSdhAqnuQ .xCflX4ukkCCEOjisj6A0 {
    flex: 1;
    padding-left: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-profile-slideout/components/modals/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB","sourcesContent":[".buttonContainer {\n    display: flex;\n    flex-direction: row-reverse;\n    margin: 30px 0 -10px;\n}\n\n.moveInModal .unitContainer {\n    flex: 1;\n    padding-left: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContainer": `tcLhcU3jJTtIByaDkItu`,
	"moveInModal": `IgS2F5nCyA_JSdhAqnuQ`,
	"unitContainer": `xCflX4ukkCCEOjisj6A0`
};
export default ___CSS_LOADER_EXPORT___;
